import { Layout } from 'antd';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import { BannerSection } from '../Organism/BannerSection';
import AppLayoutContent from '../Organism/AppsLayoutContent';
import Footer from '../Atoms/Footer';
const { Content } = Layout;

const ApteanRewardsHomePage = () => {
  return (
    <Layout className="min-h-screen flex flex-col bg-[#FAFAFA]">
      {/* Header */}
      <AppHeaderHomePageTemplate />
      
      {/* Main Content */}
      <Content className="flex-grow">
        <div className="max-w-screen-2xl mx-auto py-4 px-2">
          <BannerSection />
          <div className="bg-white rounded-lg shadow-sm mx-auto py-4">
            <AppLayoutContent />
          </div>
        </div>
      </Content>

      <Footer />
    </Layout>
  );
};

export default ApteanRewardsHomePage;